<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import { useGameStore } from '@/stores/gameStore.ts'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'

const gameStore = useGameStore()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.cdn + 'images/planet/new/128/planet_7.png'"
    :toast-text="'You have found the Ferion planet!'"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="gameStore.cdn + 'images/planet/new/128/planet_7.png'"
        :header="'You have found the Ferion planet!'"
      >
        <p class="pb-2">You have discovered the mystical planet Ferion! Legends speak of its unparalleled composition, enabling extraordinary levels of productivity.</p>
      </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>